import { Select } from '@mantine/core';

import type { UseFormReturnType } from '@mantine/form';
import type { TRemotePaymentMethod } from '@/modules/remote-payment-methods/store/types';

type Props<T> = {
  remoteMethods: TRemotePaymentMethod[];
  form: UseFormReturnType<T, (values: T) => T>;
};

export function RemoteMethodFormFields<T>(props: Props<T>) {
  const {
    remoteMethods,
    form,
  } = props;

  const remoteMethhodsPlaceholder = remoteMethods?.length === 0 ? 'Нет сторонних платёжных методов' : '';

  return (
    <Select
      label="Сторонние платёжные методы"
      placeholder={remoteMethhodsPlaceholder}
      clearable
      data={remoteMethods.map((method) => ({
        value: method.id.toString(),
        label: `${method.id} - ${method.name} [${method.paymentSystemName}]`
      }))}
      key={form.key('remoteMethodId')}
      {...form.getInputProps('remoteMethodId')}
    />
  );
};
